import axios from "axios";

const actions = {
  async fetchPromptsList({ commit, rootState }, key) {
    try {
      // For array type
      if (typeof key == "object" && key.length > 0) {
        for (let index = 0; index < key.length; index++) {
          const element = key[index];
          const api = rootState.config.configurationData.common_module;
          await axios
            .post(api.templateManagement.getTemplateByKeyEndpoint, {
              key: element
            })
            .then(response => {
              if (response.data.status === 200) {
                commit("setPromptKvp", {
                  key: element,
                  content: response.data.data.content,
                  title: response.data.data.title
                });
              } else {
                throw new Error(response.data.data.message);
              }
            });
        }
      } else {
        //For single value
        const api = rootState.config.configurationData.common_module;
        const uploadResponse = await axios
          .post(
            api.templateManagement.getTemplateByKeyEndpoint,
            {
              key: key
            },
            {
              headers: {
                Authorization: `Bearer ${rootState.auth.accessToken}`
              }
            }
          )
          .then(response => {
            if (response.data.status === 200) {
              return response.data.data;
            } else {
              throw new Error(response.data.data.message);
            }
          });

        commit("setPromptKvp", {
          key: key,
          content: uploadResponse.content,
          title: uploadResponse.title
        });
      }
    } catch (error) {
      return error;
    }
  }
};

export default actions;
